/** @flow */
import * as React from 'react';
import {AutoSizer, MultiGrid} from 'react-virtualized';
import { ListViewDataAsync, ListViewItemsAsync, GetDataStoredInDataset } from './fetchData';
import cn from 'classnames';
import { Loading } from './Loading';
import DetailWindow from './DetailWindow';
import TitleWindow from './TitleWindow';
import "abortcontroller-polyfill/dist/polyfill-patch-fetch"
import {PageView} from '../components/Tracking';
import Draggable from "react-draggable"
import { deepmerge } from "./isMergeableObject"

export default class ListTable extends React.PureComponent {

	constructor(props) {
		super(props);
		const viewID = props.match.params.id
		const datasetID = props.match.params.datasetID
		const Note = props.location.state.ViewNote
		const FieldArray = props.location.state.FieldArray
		const DetailFields = props.location.state.DetailFields
		const TitleViewField = props.location.state.TitleViewField
		const appURL = props.location.state.appURL
		let DetailViews = [];
		let numDetails = 0;
		let DetailWindowsPanelClass = ""
		if (props.location.state.DetailViews !== ""){
			DetailViews = props.location.state.DetailViews;
			numDetails = DetailViews.length
		}
		if (numDetails === 0){
			DetailWindowsPanelClass = cn("zero-width")
		}

		this.state = {
			listItems: [],
			DetailWindowsPanelClass: DetailWindowsPanelClass,
			widths: {},
			RecordsSelectedInDetailView: [],
			appURL: appURL,
			Groups: [],
			ListName: '',
			numDetails: numDetails,
			ChildFieldNames: '',
			FieldType: 'single',
			datasetID: datasetID,
			listViewID: viewID,
			TitleViewField: TitleViewField,
			FieldArray, FieldArray,
			DetailFields, DetailFields,
			loading: true,
			columnCount: 4,
			childFieldCount: 0,
			overscanColumnCount: 5,
			overscanRowCount: 100,
			row_heights: {},
			rowCount: 1,
			scrollToColumn: undefined,
			scrollToRow: undefined,
			useDynamicRowHeight: false,
			fixedColumnCount: 1,
			fixedRowCount: 1,
			rowAdder: 1,
			sortOrder: {},
			selectedRows: [],
			selectedSheetID: viewID,
			mainPanelSelection: {
				bSelection: false,
				selectedIDs: []
			},
			sheetNote: Note,
			MyClasses: "MainPanel",
			WebsiteURL: "https://www.thevantagepoint.com/",
			DetailViews: DetailViews
		};

		this._cellRenderer = this._cellRenderer.bind(this);
		this._getRowClassName = this._getRowClassName.bind(this);
		this._getRowHeight = this._getRowHeight.bind(this);
		this._noContentRenderer = this._noContentRenderer.bind(this);
		this._onColumnCountChange = this._onColumnCountChange.bind(this);
		this._onRowCountChange = this._onRowCountChange.bind(this);
		this._onScrollToColumnChange = this._onScrollToColumnChange.bind(this);
		this._onScrollToRowChange = this._onScrollToRowChange.bind(this);
		this._renderBodyCell = this._renderBodyCell.bind(this);
		this._renderLeftSideCell = this._renderLeftSideCell.bind(this);
		this.sortColumn = this.sortColumn.bind(this);
		this.selectGroup = this.selectGroup.bind(this);
		this.handleChange = this.handleChange.bind(this);
	}
	
	fetchData(appURL, datasetID, listViewID){
		ListViewDataAsync(appURL, datasetID, listViewID, this.abortController.signal)
		.then((data) => {
			let MyClasses = "MainPanel"
			let rowAdder = 1;
			if (data.FieldType === "parent"){
				var columnWidthArr = [30, 50, 0].concat(data.ChildFieldNames.map(x => 150)).concat(data.GroupArr.map(x => 30))
				var columnNumber = parseInt(data.GroupCount, 10) + parseInt(data.ChildFieldCount, 10) + 3;
				MyClasses = cn("MainPanel", "Compound")
				rowAdder = 1;
			}
			else {
				var columnWidthArr = [30, 50, 0, 400].concat(data.GroupArr.map(x => 30))
				var columnNumber = parseInt(data.GroupCount, 10) + 4;
			}
			var sortOrderArray = [];
			if (data.RowCount > 0){
				var rowsArr = new Array(data.RowCount).fill(20)
				var rowHeightArr = [100].concat(rowsArr)
				for (var i=0; i<data.RowCount; i++){
					sortOrderArray.push(i);
				}
				if (this.mounted){
					this.setState({
						rowAdder: rowAdder,
						sortOrderArray: sortOrderArray,
						FieldType: data.FieldType,
						childFieldCount: data.ChildFieldCount,
						ListName: data.Name,
						ChildFieldNames: data.ChildFieldNames,
						Groups: data.GroupArr,
						columnCount: columnNumber,
						widths: columnWidthArr,
						row_heights: rowHeightArr,
						loading: false,
						MyClasses: MyClasses
					})
				}
				let Blocks = 1;
				let myTimeout = setTimeout(() => {
					let fetchBlocks = 1000
					for (var i=0; i<data.RowCount; i+= fetchBlocks){
						ListViewItemsAsync(appURL, datasetID, listViewID, i, this.abortController.signal)
						.then((listItems) => {
							let currentList = this.state.listItems
							if (currentList !== {}){
								currentList = deepmerge(currentList, listItems)
							}
							else {
								currentList = listItems
							}
							if (this.mounted){
								this.setState({
									listItems: currentList,
									rowCount: data.RowCount + rowAdder,
									loading: false
								})
							}
						})
					}
				}, Blocks)
			}
			else {						
				this.setState({
					listItems: {},
					rowCount: 0,
					sortOrderArray: [],
					loading: false
				})
			}
		})
	}
	
	componentDidMount(){
		this.mounted = true;
		this.fetchData(this.state.appURL, this.state.datasetID, this.state.listViewID)
		PageView();
	}
	componentDidUpdate(prevProps, prevState){
		//Get last 16 characters to get the list id. 
		let ViewID = String(prevProps.history.location.pathname).substring(String(prevProps.history.location.pathname).length - prevProps.match.params.id.length) 
		if (prevProps.location.pathname !== prevProps.history.location.pathname){
			let DetailViews = [];
			let numDetails = 0;
			let DetailWindowsPanelClass = ""
			if (this.props.location.state.DetailViews !== ""){
				DetailViews = this.props.location.state.DetailViews;
				numDetails = DetailViews.length

			}
			if (numDetails === 0){
				DetailWindowsPanelClass = cn("zero-width")
			}
			if (this.mounted){

				this.setState({
					listItems: [],
					DetailWindowsPanelClass: DetailWindowsPanelClass,
					Groups: [],
					sortOrderArray: [],
					rowCount: 0,
					ListName: '',
					listViewID: ViewID,
					selectedSheetID: ViewID,
					mainPanelSelection: {
						bSelection: false,
						selectedIDs: []
					},
					selectedRows: [],
					numDetails: numDetails,
					loading: true,
					sheetNote: this.props.location.state.ViewNote,
					DetailViews: DetailViews
				})
				this.fetchData(this.state.appURL, this.state.datasetID, ViewID)
			}
		}

	}
	componentWillUnmount(){
		this.mounted = false;
		this.abortController.abort();
	}
	abortController = new window.AbortController();
	columnWidthGetter = column => {
		let widths = { ...this.state.widths };
		return widths[column]
	};
	rowHeightGetter = row => {
		let heights = { ...this.state.row_heights };
		return heights[row]
	};

	onDragStop = () => {
		this._multigrid.recomputeGridSize();
	};

	resizeCol = ({ columnIndex, deltaX }) => {
		this.setState(prevState => {
			const prevWidths = prevState.widths;

			return {
				widths: {
					...prevWidths,
					[columnIndex]: Math.max(0.15, prevWidths[columnIndex] + deltaX)
				}
			};
		});
	};
	resizeRow = ({ rowIndex, deltaY }) => {
		this.setState(prevState => {
			const prevHeights = prevState.row_heights;

			return {
				row_heights: {
					...prevHeights,
					[rowIndex]: Math.max(0.15, prevHeights[rowIndex] + deltaY)
				}
			};
		});
	};
sortColumn(column){
	var currentSort = this.state.sortOrder;
	var newSortOrder = "desc"
	var sortedList
	if (currentSort.Column === column && currentSort.Order === "desc"){
		newSortOrder = "asc"
	}
	const unsortedList = this.state.listItems
	switch (column){
		case 1:
			sortedList = sortObject(unsortedList, "RecordCount", newSortOrder)
			break;
		case 2:
			sortedList = sortObject(unsortedList, "InstanceCount", newSortOrder)
			break;
		case 3:
			//sortedList = unsortedList.sort(compareValues("Name", newSortOrder))
			sortedList = sortObject(unsortedList, "Name", newSortOrder)
			break;
		default:
			var groupToSort = column - 4;
			sortedList = sortGroup(unsortedList, groupToSort, newSortOrder)
			//figure out group sorting
			break;
	
	}
	this.setState({
		sortOrderArray: sortedList,
		sortOrder: {"Column": column, "Order": newSortOrder},
		selectedRows: []
	})
			
}
sortCompoundColumn(column){
	var currentSort = this.state.sortOrder;
	var newSortOrder = "desc"
	var sortedList
	var nonGroupColumns = 3 + parseInt(this.state.childFieldCount, 10)
	if (currentSort.Column === column && currentSort.Order === "desc"){
		newSortOrder = "asc"
	}
	const unsortedList = this.state.listItems
	switch (true){
		case (column === 1):
			sortedList = sortObject(unsortedList, "RecordCount", newSortOrder)
			break;
		case (column === 2):
			sortedList = sortObject(unsortedList, "InstanceCount", newSortOrder)
			break;
		case (column < nonGroupColumns):
			sortedList = sortObject(unsortedList, "Name" + String(column - 3), newSortOrder)
			break;
		default:
			var groupToSort = column - nonGroupColumns;
			sortedList = sortGroup(unsortedList, groupToSort, newSortOrder)
			//figure out group sorting
			break;
	
	}
	this.setState({
		sortOrderArray: sortedList,
		sortOrder: {"Column": column, "Order": newSortOrder},
		selectedRows: []
	})
			
}
handleChange(event) {
	//console.log(event)
}

selectItem = (row, ID, event) => {
	if (event.ctrlKey){
		const mainPanelSelection = {
			bSelection: true,
			selectedIDs: this.state.mainPanelSelection.selectedIDs.concat(ID),
		}
		
		this.setState({
			selectedRows: this.state.selectedRows.concat(ID),
			mainPanelSelection: mainPanelSelection,
			lastSelection: row
		});
	}
	else if (event.shiftKey){
		if (this.state.lastSelection !== ""){
			var finalArray = [];
			var IDArray = [];
			const numToSelect = Math.abs(this.state.lastSelection - row)
			if (this.state.lastSelection > row){
				for (var i=row; i<=this.state.lastSelection; i++){
					finalArray.push(i);
					IDArray.push(String(this.state.listItems[i - 1].ID))
				}
			}
			else {
				for (var i=row; i>=this.state.lastSelection; i--){
					finalArray.push(i);
					IDArray.push(String(this.state.listItems[i - 1].ID))
				}
			}
			const mainPanelSelection = {
				bSelection: true,
				selectedIDs: IDArray,
			}
			this.setState({
				selectedRows: IDArray,
				mainPanelSelection: mainPanelSelection,
				lastSelection: row
			});
		}
	}
	else {

		const mainPanelSelection = {
			bSelection: true,
			selectedIDs: [ID]
		}
		this.setState({
			selectedRows: ID,
			mainPanelSelection: mainPanelSelection,
			lastSelection: row
		});
	}
}

selectGroup(ID, groupNum){
	const listSelect = this.state.listItems;
	const selectedRows = getGroupMembers(listSelect, groupNum);
	const mainPanelSelection = {
		bSelection: true,
		selectedIDs: ['group' + ID]
	}
	this.setState({
		mainPanelSelection: mainPanelSelection,
		selectedRows: selectedRows,
	});
}
getTitleSelection = (dataFromChild) => {
	this.props.openTitleWindow(dataFromChild)
}
getDetailSelection = (dataFromChild) => {
 this.setState({
	 RecordsSelectedInDetailView: dataFromChild
 })
}
multiSelectItem = (row, ID, event) => {
	if (event.buttons == 1){
		//alert(event.buttons)

		const mainPanelSelection = {
			bSelection: true,
			selectedIDs: this.state.mainPanelSelection.selectedIDs.concat(ID),
		}
		
		this.setState({
			selectedRows: this.state.selectedRows.concat(ID),
			mainPanelSelection: mainPanelSelection,
			lastSelection: row
		});
	}
}
	render() {
		const {
			widths,
			columnCount,
			overscanColumnCount,
			overscanRowCount,
			height,
			row_heights,
			rowCount,
			MyClasses,
			DetailViews,
			listViewID,
			datasetID,
			mainPanelSelection,
			WebsiteURL,
			TitleViewField,
			FieldArray,
			DetailFields,
			appURL,
			DetailWindowsPanelClass
		} = this.state;
		return (
			<div className="FillWindow">
				{this.state.loading === true
				? <Loading />
				:<div>
				<div className="flex-grid">
					<div className="TitleWindowPanel">
						<TitleWindow appURL={appURL} id={listViewID} datasetID={this.state.datasetID} mainPanelSelection={mainPanelSelection} detailSelection={this.state.RecordsSelectedInDetailView} Note={this.state.sheetNote} callbackFromParent={this.getTitleSelection} DefaultField={TitleViewField} FieldArray={FieldArray}></TitleWindow>
					</div>
					<div className={MyClasses}>

						<AutoSizer>
							{({width, height}) => (
								<div>
									{this.state.FieldType === 'parent'
									? <div className="ParentFieldName" style={{width: width, textAlign: "center", height: '20px'}}>{this.state.ListName}</div>
									: <div className="hiddenContent"></div>
									}
								<MultiGrid
									{...this.state}
									widths={widths}
									ref={(ref) => this._multigrid = ref}
									cellRenderer={this._cellRenderer}
									className={"BodyGrid"}
									columnWidth={({index}) => {
										return widths[index]
									}}
									columnCount={columnCount}
									height={height}
									noContentRenderer={this._noContentRenderer}
									overscanColumnCount={overscanColumnCount}
									overscanRowCount={overscanRowCount}
									rowHeight={({index}) => {
									return row_heights[index]
									}}
									rowCount={rowCount}
									width={width}>
								</MultiGrid>
								</div>
							)}
						</AutoSizer>
					</div>

					<div className={cn(DetailWindowsPanelClass, "DetailWindowPanel")}>
						{DetailViews.map((value, num) => {
							return (
								<DetailWindow appURL={appURL} key={num} id={listViewID} numDetails={this.state.numDetails} datasetID={datasetID} mainPanelSelection={mainPanelSelection} DefaultField={value} callbackFromParent={this.getDetailSelection} FieldArray={FieldArray} DetailFields={DetailFields}></DetailWindow>
							)
						})}
					</div>
					</div>
				</div>
				}
			</div>
		);
	}

	_cellRenderer({columnIndex, key, rowIndex, style}) {
		if (this.state.FieldType === 'parent'){
			if (rowIndex === 0){
				return this._renderCompoundHeaderCell({columnIndex, key, rowIndex, style})
			}
			else {
	
				if (columnIndex === 0) {
					return this._renderLeftSideCell({columnIndex, key, rowIndex, style});
				} else {
					return this._renderCompoundBodyCell({columnIndex, key, rowIndex, style});
				}
			}

		}
		else {

			if (rowIndex === 0){
				return this._renderHeaderCell({columnIndex, key, rowIndex, style});
			}
			else {
				
				if (columnIndex === 0) {
					return this._renderLeftSideCell({columnIndex, key, rowIndex, style});
				} else {
					return this._renderBodyCell({columnIndex, key, rowIndex, style});
				}
			}
		}
	}  

	_getDatum(index) {
		return this.state.listItems[this.state.sortOrderArray[index - 1]]
	}

	_getRowClassName(row) {
		return row % 2 === 0 ? "evenRow" : "oddRow";
	}

	_getRowHeight({index}) {
		if (index === 0){
			 return 100;
		}
		else {
			return 20;
		}
	}

	_noContentRenderer() {
		return <div className="noCells">No cells</div>;
	}

	_renderHeaderCell({columnIndex, key, rowIndex, style}) {
		const classNames = cn("cell", "HeaderRow");
		let content;
		style = {
			...style,
			width: this.columnWidthGetter(columnIndex),
			height: this.rowHeightGetter(rowIndex)
		};
		switch (columnIndex) {
			case 0:
				return (
					<div className={classNames} key={key} style={style}>
						<Draggable
							axis="y"
							defaultClassNameDragging="DragHandleActive"
							onDrag={(event, {deltaY}) => {
								this.resizeRow({rowIndex, deltaY});
							}}
							onStop={this.onDragStop}
							position={{x:0}}
							zIndex={999}
						>
							<span className="float-bottom DragHandleRow"></span>
						</Draggable>
					</div>
				);
			case 1:
				content = <div className="rotate rotate-list"># Records<span className="float-rotate DragHandleIcon">::</span></div>;
				break;
			case 2:
				content = <div className="rotate rotate-list"># Instances<span className="float-rotate DragHandleIcon">::</span></div>;
				break;
			case 3:
				content = <div title={this.state.ListName} className="ListFieldName"><span className="AlignBottom">{this.state.ListName}</span><span className="float-right DragHandleIcon">::</span></div>;
				break;
			default:
				content = <div title ={this.state.Groups[columnIndex - 4].groupName[0]} className="rotate rotate-list">{this.state.Groups[columnIndex - 4].groupName[0]}</div>;
				return (
					<div className={cn(classNames, "sortDown")} key={key} style={style} onClick={(event) => this.selectGroup(this.state.Groups[columnIndex-4].groupID[0], columnIndex-4, event)} onDoubleClick={() => this.sortColumn(columnIndex)}>
						{content}
					</div>
				);
				
			}
			return (
				<div className={cn(classNames, "sortDown")} key={key} style={style} onDoubleClick={() => this.sortColumn(columnIndex)}>
					<Draggable
						axis="x"
						defaultClassNameDragging="DragHandleActive"
						onDrag={(event, {deltaX}) => {
							this.resizeCol({columnIndex, deltaX});
						}}
						onStop={this.onDragStop}
						position={{x:0}}
						zIndex={999}
					>
					{content}
					</Draggable>	
				</div>
			);
	}
	_renderCompoundHeaderCell({columnIndex, key, rowIndex, style}) {
		const classNames = cn("cell", "HeaderRow");
		var nonGroupColumns = 3 + parseInt(this.state.childFieldCount, 10)
		let content;
		style = {
			...style,
			width: this.columnWidthGetter(columnIndex),
			height: this.rowHeightGetter(rowIndex)
		};
		switch (true) {
			case (columnIndex === 0):
				return (
					<div className={classNames} key={key} style={style}>
					<Draggable
						axis="y"
						defaultClassNameDragging="DragHandleActive"
						onDrag={(event, {deltaY}) => {
							this.resizeRow({rowIndex, deltaY});
						}}
						onStop={this.onDragStop}
						position={{x:0}}
						zIndex={999}
					>
						<span className="float-bottom DragHandleRow"></span>
					</Draggable>
					</div>
				);
			case (columnIndex === 1):
				content = <div className="rotate rotate-child"># Records<span className="float-rotate DragHandleIcon">::</span></div>;
				break;
			case (columnIndex === 2):
				content = <div className="rotate rotate-child"># Instances<span className="float-rotate DragHandleIcon">::</span></div>;
				break;
			case (columnIndex < nonGroupColumns):
				content = <div title={this.state.ChildFieldNames[columnIndex - 3]} className="ListFieldName"><span className="AlignBottom">{this.state.ChildFieldNames[columnIndex - 3]}</span><span className="float-right DragHandleIcon">::</span></div>;
				break;
			default:
				content = <div title={this.state.Groups[columnIndex - nonGroupColumns].groupName[0]} className="rotate rotate-child">{this.state.Groups[columnIndex - nonGroupColumns].groupName[0]}</div>;
				return (
					<div className={cn(classNames, "sortDown")} key={key} style={style} onClick={() => this.selectGroup(this.state.Groups[columnIndex-nonGroupColumns].groupID[0], columnIndex-nonGroupColumns)} onDoubleClick={() => this.sortCompoundColumn(columnIndex)}>
						{content}
					</div>
				);
			}
			return (
				<div className={cn(classNames, "sortDown")} key={key} style={style} onDoubleClick={() => this.sortCompoundColumn(columnIndex)}>
					<Draggable
						axis="x"
						defaultClassNameDragging="DragHandleActive"
						onDrag={(event, {deltaX}) => {
							this.resizeCol({columnIndex, deltaX});
						}}
						onStop={this.onDragStop}
						position={{x:0}}
						zIndex={999}
					>
					{content}
					</Draggable>
				</div>
			);
	}
	

	_renderCompoundBodyCell({columnIndex, key, rowIndex, style}) {
		const rowClass = this._getRowClassName(rowIndex - 1);
		const datum = this._getDatum(rowIndex);
		let content;
		let isSelected;
		style = {
			...style,
			width: this.columnWidthGetter(columnIndex),
			height: this.rowHeightGetter(rowIndex)
		};
		if (this.state.selectedRows.indexOf(String(datum.ID)) >= 0){
			isSelected = true;
		}
		else {
			isSelected = false;
		}
		const classNames = cn(rowClass, "cell", {
				"selected": isSelected
		});

		switch (true) {
			case (columnIndex === 1):
				content = <span>{datum.RecordCount}</span>;
				break;
			case (columnIndex === 2):
				content = <span>{datum.InstanceCount}</span>;
				break;
			case (columnIndex < 3 + this.state.childFieldCount):
				content = <span title={datum["Name" + String(columnIndex-3)]}>{datum["Name" + String(columnIndex-3)]}</span>;
				break;
			default:
				const GroupCount = parseInt(datum.GroupCount, 10)
				for (let groupIndex = 0; groupIndex<GroupCount; groupIndex++){
					if (datum.hasOwnProperty("GroupIndex" + String(groupIndex))){
						if (String(datum["GroupIndex" + String(groupIndex)]) === String(columnIndex - this.state.childFieldCount - 3)){
							if (String(datum["GroupMembership" + String(groupIndex)]) === "2"){
								content = <div className="centered checkedBox" onChange={() => this.handleChange()}></div>
								break;
							}
							else if (String(datum["GroupMembership" + String(groupIndex)]) === "1"){
								content = <div className="centered xedBox" onChange={() => this.handleChange()}></div>
								break;
							}
						}
						else {
							content = <div className="centered uncheckedBox" onChange={() => this.handleChange()}></div>
						}
					}
					else {
						content = <div className="centered uncheckedBox" onChange={() => this.handleChange()}></div>
						break;
					}
				}
				break;
		}
			return (
				<div className={classNames} key={key} style={style} onMouseEnter={this.multiSelectItem.bind(this, rowIndex, datum.ID)} onClick={this.selectItem.bind(this, rowIndex, datum.ID)}>
				{content}
			</div>
		);
	}
	_renderBodyCell({columnIndex, key, rowIndex, style}) {
		const rowClass = this._getRowClassName(rowIndex - 1);
		const datum = this._getDatum(rowIndex);
		let content;
		let isSelected;
		style = {
			...style,
			width: this.columnWidthGetter(columnIndex),
			height: this.rowHeightGetter(rowIndex)
		};
		if (this.state.selectedRows.indexOf(String(datum.ID)) >= 0){
			isSelected = true;
		}
		else {
			isSelected = false;
		}
		const classNames = cn(rowClass, "cell", {
				"selected": isSelected
		});

		switch (columnIndex) {
			case 1:
				content = <span>{datum.RecordCount}</span>;
				break;
			case 2:
				content = <span>{datum.InstanceCount}</span>;
				break;
			case 3:
				content = <span title={datum.Name}>{datum.Name}</span>;
				break;
			default:
				const GroupCount = parseInt(datum.GroupCount, 10)
				for (let groupIndex = 0; groupIndex<GroupCount; groupIndex++){
					if (datum.hasOwnProperty("GroupIndex" + String(groupIndex))){
						if (String(datum["GroupIndex" + String(groupIndex)]) === String(columnIndex - 4)){
							if (String(datum["GroupMembership" + String(groupIndex)]) === "2"){
								content = <div className="centered checkedBox" onChange={() => this.handleChange()}></div>
								break;
							}
							else if (String(datum["GroupMembership" + String(groupIndex)]) === "1"){
								content = <div className="centered xedBox" onChange={() => this.handleChange()}></div>
								break;
							}
						}
						else {
							content = <div className="centered uncheckedBox" onChange={() => this.handleChange()}></div>
						}
					}
					else {
						content = <div className="centered uncheckedBox" onChange={() => this.handleChange()}></div>
						break;
					}
				}
				break;
		}
			return (

				<div className={classNames} key={key} style={style} onClick={this.selectItem.bind(this, rowIndex, datum.ID)} onMouseEnter={this.multiSelectItem.bind(this, rowIndex, datum.ID)}>
				{content}
			</div>
		);
	}
	_renderLeftSideCell({key, rowIndex, style}) {
		const datum = this._getDatum(rowIndex);
		const classNames = cn("cell", "letterCell");

		// Don't modify styles.
		// These are frozen by React now (as of 16.0.0).
		// Since Grid caches and re-uses them, they aren't safe to modify.
		style = {
			...style,
			backgroundColor: "lightgray",
			width: this.columnWidthGetter(0),
			height: this.rowHeightGetter(rowIndex)
		};
			return (
				<div className={classNames} key={key} style={style}>{rowIndex}
					<Draggable
						axis="y"
						defaultClassNameDragging="DragHandleActive"
						onDrag={(event, {deltaY}) => {
							this.resizeRow({rowIndex, deltaY});
						}}
						onStop={this.onDragStop}
						position={{x:0}}
						zIndex={999}
					>
						<span className="float-bottom DragHandleRow"></span>
					</Draggable>
				</div>
			);
	}

	_updateUseDynamicRowHeights(value) {
		this.setState({
			useDynamicRowHeight: value,
		});
	}

	_onColumnCountChange(event) {
		const columnCount = parseInt(event.target.value, 10) || 0;

		this.setState({columnCount});
	}

	_onRowCountChange(event) {
		const rowCount = parseInt(event.target.value, 10) || 0;

		this.setState({rowCount});
	}

	_onScrollToColumnChange(event) {
		const {columnCount} = this.state;
		let scrollToColumn = Math.min(
			columnCount - 1,
			parseInt(event.target.value, 10),
		);

		if (isNaN(scrollToColumn)) {
			scrollToColumn = undefined;
		}

		this.setState({scrollToColumn});
	}

	_onScrollToRowChange(event) {
		const {rowCount} = this.state;
		let scrollToRow = Math.min(rowCount - 1, parseInt(event.target.value, 10));

		if (isNaN(scrollToRow)) {
			scrollToRow = undefined;
		}

		this.setState({scrollToRow});
	}
}
// function for dynamic sorting
function compareValues(key, order='asc') {

	return function(a, b) {
		if(!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
			// property doesn't exist on either object
				return 0; 
		}
		const varA = (typeof a[key] === 'string') ? 
			a[key].toUpperCase() : a[key];
		const varB = (typeof b[key] === 'string') ? 
			b[key].toUpperCase() : b[key];

		let comparison = 0;
		if (varA > varB) {
			comparison = 1;
		} else if (varA < varB) {
			comparison = -1;
		}
		return (
			(order === 'desc') ? (comparison * -1) : comparison
		);
	};
}
function compareCompoundValues(key, order='asc', column) {

	return function(a, b) {
		if(!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
			// property doesn't exist on either object
				return 0; 
		}
		const varA = (typeof a[key][column] === 'string') ? 
			a[key][column].toUpperCase() : a[key][column];
		const varB = (typeof b[key][column] === 'string') ? 
			b[key][column].toUpperCase() : b[key][column];

		let comparison = 0;
		if (varA > varB) {
			comparison = 1;
		} else if (varA < varB) {
			comparison = -1;
		}
		return (
			(order === 'desc') ? (comparison * -1) : comparison
		);
	};
}
function compareGroups(groupToSort, order='asc') {
	return function(a, b) {
		if(!a.hasOwnProperty("GroupArr") || !b.hasOwnProperty("GroupArr")) {
			// property doesn't exist on either object
			return 0; 
		}
		const varA = (a["GroupArr"].indexOf(String(groupToSort)) >= 0)
		const varB = (b["GroupArr"].indexOf(String(groupToSort)) >= 0)
		
		if (order==='asc'){
			return (varA === varB)? 0 : varA? 1 : -1;
		}
		else {
			return (varA === varB)? 0 : varA? -1 : 1;
		}
	};
}
function getGroupMembers(ListObject, groupToSort) {
	const groupMemberArray = [];
	for (var ListItem in ListObject) {
		if (ListObject.hasOwnProperty(ListItem)) {
			let GroupCount = parseInt(ListObject[ListItem].GroupCount, 10)
			for (let i=0;i<GroupCount;i++){
				if (parseInt(ListObject[ListItem]["GroupIndex" + String(i)], 10) === groupToSort && parseInt(ListObject[ListItem]["GroupMembership" + String(i)], 10) === 2){
					groupMemberArray.push(String(ListObject[ListItem].ID))
				}
			}
		}
	}
	return groupMemberArray;
}

function sortObject(obj, propMatch, order) {
  var arr = [];
  for (var prop in obj) {
	  if (obj.hasOwnProperty(prop)) {
		if (obj[prop].hasOwnProperty(propMatch)){
		  if (propMatch === "RecordCount" || propMatch === "InstanceCount"){
			arr.push({
			  'key': prop,
			  'value': parseInt(obj[prop][propMatch], 10)
			})
		  }
		  else {
			arr.push({
			  'key': prop,
			  'value': String(obj[prop][propMatch]).toLocaleUpperCase()
			});
		  }
		}
	  }
  }
  var NotANumber = isNaN(arr[0].value);
  arr.sort(function(a, b) {
	if (NotANumber){
	  return ((order === 'desc') ? a.value.localeCompare(b.value) : b.value.localeCompare(a.value) );
	}
	else {
	  return ((order === 'desc') ? b.value - a.value : a.value - b.value);
	}
  });
  let sortOrder = arr.map(function(key, index){
	return key.key;
  })
  return sortOrder; // returns array
}

function sortGroup(obj, propMatch, order) {
	var arr = [];
	for (var prop in obj) {
		if (obj.hasOwnProperty(prop)) {
			let GroupCount = parseInt(obj[prop].GroupCount, 10)
			if (GroupCount === 0){
				arr.push({
					'key': prop,
					'value': 0
				})
			}
			else {
				for (let groupIndex = 0; groupIndex < GroupCount; groupIndex++){
					if (parseInt(obj[prop]["GroupIndex" + String(groupIndex)],10) === propMatch){
						arr.push({
							'key': prop,
							'value': parseInt(obj[prop]["GroupMembership" + String(groupIndex)], 10)
						})
						break;
					}
					else if (groupIndex === GroupCount - 1){
						arr.push({
							'key': prop,
							'value': 0
						})
					}
				}
			}
		}
	}
	var property_type = typeof arr[0].value;
	arr.sort(function(a, b) {
	  if (property_type === 'string'){
		return ((order === 'desc') ? a.value.localeCompare(b.value) : b.value.localeCompare(a.value) );
	  }
	  else {
		return ((order === 'desc') ? b.value - a.value : a.value - b.value);
	  }
	});
	let sortOrder = arr.map(function(key, index){
	  return key.key;
	})
	return sortOrder; // returns array
  }